import React from 'react';
import {I18nextProvider} from 'react-i18next';
import Layout from '@/Fi16100/Layouts/Layout.jsx';
import {Head, usePage} from '@inertiajs/react';
import Container from 'react-bootstrap/Container';
import Link from '@/Fi16100/Components/Link';
import {initI18next} from '@/Fi16100/Helpers/initI18next.js';

export default function NotFound(props) {
	const locale = String(usePage().props.locale);
	const i18next = initI18next(locale);
	const t = i18next.t;

	return (
		<I18nextProvider i18n={i18next} defaultNS="fi16100">
			<Head>
				<title>{t('notFound.title')}</title>
			</Head>

			<Layout mainClassName="not-found">
				<Container className="py-5 text-center">
					<h1 className="text-uppercase fw-bold fs-4 mb-4">
						{ t('notFound.header') }
					</h1>

					<p className="mb-4">
						{ t('notFound.pageNotFound') }
					</p>

					<Link href={route('fi16100.home')} className="btn btn-primary rounded-1 px-3">
						{ t('notFound.moveToFrontPage') }
					</Link>
				</Container>
			</Layout>
		</I18nextProvider>
	);
}
